import { render } from "./PrintDocumentSender.vue?vue&type=template&id=deb15dc4&scoped=true&ts=true"
import script from "./PrintDocumentSender.vue?vue&type=script&lang=ts"
export * from "./PrintDocumentSender.vue?vue&type=script&lang=ts"

import "./PrintDocumentSender.vue?vue&type=style&index=0&id=deb15dc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb15dc4"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput,QSpinnerFacebook});
